import type { Theme } from '@mui/material';
import { Grid2 as Grid } from '@mui/material';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';
import { pxToRem } from '@/utils/pxToRem';

type SummaryCardProps = ComponentProps<typeof Grid>;

const summaryCardFooterStyles = {
  base: {
    marginTop: 'auto',
    justifyContent: 'flex-end',
    borderTop: (theme: Theme) => `1px solid ${theme.palette.divider}`,
    paddingTop: '0.75rem',
  },
};

const SummaryCardContentGrid = ({ children, sx, ...props }: SummaryCardProps) => {
  return (
    <Grid
      display='grid'
      sx={combineSx({ gap: pxToRem(24), placeContent: 'start', width: '100%' }, sx)}
      data-id='summary-card-content-grid'
      {...props}
    >
      {children}
    </Grid>
  );
};

const SummaryCardFooter = ({ children, sx, ...props }: SummaryCardProps) => {
  return (
    <Grid
      display='flex'
      container
      sx={combineSx(summaryCardFooterStyles.base, sx)}
      data-id='summary-card-footer'
      {...props}
    >
      {children}
    </Grid>
  );
};

export { SummaryCardContentGrid, SummaryCardFooter };
